import { cloneDeep } from 'lodash';
import { Adapter } from './adapter';

export class GoogleTagManagerAdapter extends Adapter {
  static get #defaultOptions() {
    return {
      dataLayerName: 'dataLayer',
    };
  }

  get type() {
    return 'google';
  }

  constructor({ logger, adapterOptions = {} }) {
    super({ logger: logger.withPrefix('google') });

    adapterOptions = {
      ...GoogleTagManagerAdapter.#defaultOptions,
      ...adapterOptions,
    };

    this.dataLayerName = adapterOptions.dataLayerName;
    this.log('adapter configured', { adapterOptions });
  }

  get #dataLayer() {
    return window[this.dataLayerName] || [];
  }

  trackEvent(eventName, eventData) {
    this.logEvent(`custom-tracking:${eventName}`, {
      eventName,
      eventData,
      [this.dataLayerName]: this.#dataLayer,
    });

    this.#dataLayer.push({ event: eventName, ...eventData });
  }

  trackClick(event, eventName, eventData) {
    this.logEvent(event.type, 'trackClick', {
      event,
      eventName,
      eventData,
      [this.dataLayerName]: this.#dataLayer,
    });

    this.#dataLayer.push({ event: eventName, ...eventData });
  }

  trackFormSubmit(event, $form, onSubmitEventName, onSubmitEventData) {
    const convertedFieldData = this.convertDataToFieldData(onSubmitEventData, $form);

    this.logEvent(event.type, 'trackFormSubmit', {
      event,
      $form,
      onSubmitEventName,
      onSubmitEventData,
      convertedFieldData,
      [this.dataLayerName]: this.#dataLayer,
    });

    this.#dataLayer.push({ event: onSubmitEventName, ...convertedFieldData });
  }

  trackGFFormConfirmation(event, formId) {
    this.logEvent(event.type, 'trackGFFormConfirmation', {
      event,
      formId,
      [this.dataLayerName]: this.#dataLayer,
    });
  }
}
